import React, { useEffect, useState } from "react";
import axios from "axios";
import { Cookies } from "react-cookie";
import Loading from "../Loading";
import { ErrorAlert } from "../middleware/AlertMsg";
import "./salesReport.css";
import { csvGetReq } from "../middleware/AxiosApisCallExport";
import fileDownload from "js-file-download";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination,TableSortLabel
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell,SortHeaderTableCell} from '../Partials/TableStyle'

const SalesSummaryReport = () => {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [machineNameFilter, setMachineNameFilter] = useState();
  const [refillerNameFilter, setRefillerNameFilter] = useState();
  const [isLoading, setLoading] = useState(false);
  const [refillerdata, setRefillerData] = useState();
  const [machinedata, setMachineData] = useState();

  const [reportData, setReportData] = useState([]);
 
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [load, setLoad] = useState(false);
 
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
   // const baseUrl = "https://officejeeves.com";
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('productName');
  const handleInputs = async () => {
    salesApi();
  };

  const getRefillRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${baseUrl}/api/User/DataList?role=Refiller`,
        { headers: { Authorization: "Bearer " + token } }
      );
      const data = res.data?.data;
      setRefillerData(data);
      setLoading(false);
    } catch (error) {
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  };
  const getMachineRequests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/getallmachines`, {
        headers: { Authorization: "Bearer " + token },
      });
      const data = res.data?.data;
      setMachineData(data);
      setLoading(false);
    } catch (error) {
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  };
  useEffect(() => {
    getRefillRequests();
    getMachineRequests();
  }, []);

  const handleDownload = async () => {
    try {
      if (!startDate || !endDate) {
        alert('Please fill in both start and end date fields.');
        return;
      }
      setLoading(true);
      let url = `salesreport/groupby/exportCSV?start=${startDate}&end=${endDate}`
      if(machineNameFilter && machineNameFilter.length>0){
        url +=  `&machineNameFilter=${machineNameFilter}`
      }
      if(refillerNameFilter && refillerNameFilter.length>0){
        url +=`&refillerNameFilter=${refillerNameFilter}`
      }

      const response = await csvGetReq(url);
      if (response) {
        fileDownload(response, "salesReport.csv");
        setLoading(false);
      }
    } catch (error) {
      ErrorAlert({ title: "Failed", message: error.message });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    // Reset page to 0 after a search
    setPage(0);
  }, [searchQuery]);

  const filteredData = reportData.filter((item) => {
    return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });

  const sortedRows = filteredData.sort((a, b) => {
    if (orderBy === 'saleQuantity') {
      return order === 'asc' ? a[orderBy] - b[orderBy] : b[orderBy] - a[orderBy];
    }
    return order === 'asc' ? a[orderBy].localeCompare(b[orderBy]) : b[orderBy].localeCompare(a[orderBy]);
  });

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const salesApi = async () => {
    try {
      if (!startDate || !endDate) {
        alert('Please fill in both start and end date fields.');
        return;
      }
      setLoading(true);
      let url = `${baseUrl}/api/salesreport/groupby?start=${startDate}&end=${endDate}`
      if(machineNameFilter && machineNameFilter.length>0){
        url +=  `&machineNameFilter=${machineNameFilter}`
      }
      if(refillerNameFilter && refillerNameFilter.length>0){
        url +=`&refillerNameFilter=${refillerNameFilter}`
      }
      const salesData = await axios.get(
        url,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );
      const data = salesData.data.data;
      setReportData(data);
      if (data) {
        setLoading(false);
      }
    } catch (error) {
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
      setLoading(false);
    }
  };

  return (
    <div className="mainSales">
      <h4 className="reportHead">Sales Summary Report</h4>

      <div className="inputform">
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <select
          className="dropdown"
          onChange={(e) => setMachineNameFilter(e.target.value)}
        >
          <option value="">Select Machine</option>
          {machinedata?.map((item, i) => (
            <option key={item.machinename} value={item.machinename}>
              {item.machinename}
            </option>
          ))}
        </select>

        <select
          className="dropdown"
          onChange={(e) => setRefillerNameFilter(e.target.value)}
        >
          <option value="">Select Refiller</option>
          {refillerdata?.map((item, i) => (
            <option key={item.first_name} value={item.first_name}>
              {item.first_name}
            </option>
          ))}
        </select>

        <br />
        <button onClick={handleInputs} type="button" className="submit-btn">
          Submit
        </button>
        <button
          onClick={handleDownload}
          type="button"
          className="downlaodsubmit-btn"
        >
          Download CSV
        </button>
      </div>
      <hr />

      <div className="salesData">
        {/* <h3>All Sales Data</h3> */}

          <div className="search-div">
            <label>Search : </label>
            <input
              value={searchQuery}
              onChange={handleSearch}
              variant="outlined"
              size="small"
              // className="search-field"
            />
          </div>
        <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <StyledTableRow>
            <HeaderTableCell>Product Code</HeaderTableCell>
              {/* <HeaderTableCell>Product Name</HeaderTableCell> */}
              <HeaderTableCell>
              <SortHeaderTableCell
                  active={orderBy === 'productName'}
                  direction={orderBy === 'productName' ? order : 'asc'}
                  onClick={() => handleSortRequest('productName')}
                >
                  Product Name
                </SortHeaderTableCell>
              </HeaderTableCell>
              <HeaderTableCell>MRP</HeaderTableCell>
              <HeaderTableCell>Machine Name</HeaderTableCell>
              <HeaderTableCell>Refiller Name</HeaderTableCell>
              <HeaderTableCell>Warehouse Name</HeaderTableCell>
              {/* <HeaderTableCell>Total Sale Qty</HeaderTableCell> */}
              <HeaderTableCell>
              <SortHeaderTableCell
                  active={orderBy === 'saleQuantity'}
                  direction={orderBy === 'saleQuantity' ? order : 'asc'}
                  onClick={() => handleSortRequest('saleQuantity')}
                >
                  Total Sale Qty.
                </SortHeaderTableCell>
                </HeaderTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={8}>
                  <Loading />
                </TableCell>
              </TableRow>
              ) : (
                sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item,index) =>  (
                <StyledTableRow key={item.id} sx={{
                  backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                }}>
                  <StyledTableCell>{item.productCode}</StyledTableCell>
                  <StyledTableCell>{item.productName}</StyledTableCell>
                  <StyledTableCell align="right">{item.MRP}</StyledTableCell>
                  <StyledTableCell>{item.machineName}</StyledTableCell>
                  <StyledTableCell>{item.refillerName}</StyledTableCell>
                  <StyledTableCell>{item.warehouseName}</StyledTableCell>
                  <StyledTableCell align="right"><b>{item.saleQuantity}</b></StyledTableCell>
              </StyledTableRow>
            ))
          )}
          </TableBody>
        </Table>
        <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={sortedRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
       </TableContainer>
      </div>
    </div>
  );
};

export default SalesSummaryReport;
